import { createSelector } from 'redux-starter-kit';

const authSelector = (state: any) => state.auth;

export const authSelectors = {
  organizationData: createSelector(
    authSelector,
    substate => substate.organization
  ),
  token: createSelector(authSelector, subState => subState.token)
};
